if (!customElements.get('image-tiles-slider')) {
  customElements.define(
    'image-tiles-slider',
    class ImageTilesSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.image-tiles__track');
        this.controls = this.querySelector('[data-image-tiles-controls]');
        this.progressBar = this.querySelector('[data-image-tiles-progress]');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrev = this.onPrev.bind(this);
        this.onNext = this.onNext.bind(this);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prevButton.addEventListener('click', this.onPrev);
        this.nextButton.addEventListener('click', this.onNext);
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.track);

        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
      }

      get maxScroll() {
        return Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      }

      get step() {
        const item = this.track.querySelector('.image-tiles__item');
        if (!item) return this.track.clientWidth * 0.8;
        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      onPrev(event) {
        event.preventDefault();
        this.track.scrollBy({ left: -this.step, behavior: 'smooth' });
      }

      onNext(event) {
        event.preventDefault();
        this.track.scrollBy({ left: this.step, behavior: 'smooth' });
      }

      onScroll() {
        this.update();
      }

      onResize() {
        this.update();
      }

      update() {
        const maxScroll = this.maxScroll;
        const hasOverflow = maxScroll > 2;

        if (this.controls) {
          this.controls.hidden = !hasOverflow;
        }

        if (!hasOverflow) return;

        const progress = Math.min(Math.max(this.track.scrollLeft / maxScroll, 0), 1);
        const thumbWidth = Math.max((this.track.clientWidth / this.track.scrollWidth) * 100, 10);
        const leftPercent = progress * (100 - thumbWidth);

        if (this.progressBar) {
          this.progressBar.style.width = `${thumbWidth}%`;
          this.progressBar.style.left = `${leftPercent}%`;
        }

        this.prevButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }
  );
}
